import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
export const TBGContext = React.createContext(null);
export const ToggleButtonGroup = ({ children, className, size = "large", ...rest }) => {
    const providerValue = {
        size,
    };
    return (_jsx(TBGContext.Provider, { value: providerValue, children: _jsx("div", { className: classNames("eds-toggle-button-group", className), ...rest, children: children }) }));
};
